(function() {
  'use strict';

  // Check if cart contains inside-dhaka-only products
  function hasInsideDhakaProducts() {
    const items = document.querySelectorAll('[data-inside-dhaka="true"]');
    return items.length > 0;
  }

  // Create and show the location selection modal
  function showLocationModal(callback) {
    const existingModal = document.getElementById('inside-dhaka-modal');
    if (existingModal) existingModal.remove();

    const modal = document.createElement('div');
    modal.id = 'inside-dhaka-modal';
    modal.className = 'inside-dhaka-modal-overlay';
    modal.style.cssText = `
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(40, 12, 6, 0.62);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999999;
      padding: 20px;
    `;

    modal.innerHTML = `
      <div class="deshio-dhaka-card" style="
        background: linear-gradient(180deg, #fdfaf4 0%, #f5e9d5 100%);
        border: 1px solid rgba(139, 58, 42, .22);
        border-radius: 16px;
        padding: 34px 26px 26px;
        max-width: 470px;
        width: 100%;
        position: relative;
        box-shadow: 0 22px 60px -18px rgba(40, 12, 6, .55);
        text-align: center;
        font-family: 'Hind Siliguri', 'GeneralSans', system-ui, sans-serif;
      ">
        <button class="inside-dhaka-modal-close" style="
          position: absolute;
          top: 12px;
          right: 12px;
          width: 34px;
          height: 34px;
          background: rgba(74, 42, 24, .08);
          border: 1px solid rgba(74, 42, 24, .16);
          border-radius: 9px;
          font-size: 17px;
          cursor: pointer;
          color: #4a2a18;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        " aria-label="Close">&#10005;</button>

        <div style="
          width: 56px;
          height: 56px;
          background: #6b2a1e;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 14px auto;
          font-size: 27px;
          box-shadow: 0 6px 16px -6px rgba(40, 12, 6, .6);
        ">&#128757;</div>

        <h3 style="
          font-size: 21px;
          font-weight: 700;
          margin: 0 0 8px 0;
          color: #6b2a1e;
          line-height: 1.45;
        ">অর্ডারটি কোথায় ডেলিভারি করবেন?</h3>

        <p style="
          font-size: 14.5px;
          color: #5c3317;
          margin: 0 0 22px 0;
          line-height: 1.6;
        ">চেকআউট করার আগে আপনার ডেলিভারির এলাকা নির্বাচন করুন।</p>

        <div style="
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        ">
          <button type="button" class="inside-dhaka-inside-btn" style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 18px 12px;
            border: 2px solid #6b2a1e;
            border-radius: 12px;
            background: #6b2a1e;
            cursor: pointer;
            transition: all .18s ease;
            font-family: inherit;
          ">
            <span style="font-size: 26px; margin-bottom: 6px; display: block;">&#128205;</span>
            <span style="font-size: 15px; font-weight: 700; color: #f7e6c4; display: block;">ঢাকার ভিতরে</span>
            <span style="font-size: 12px; color: rgba(247,230,196,.80); margin-top: 3px; display: block;">সরাসরি ডেলিভারি</span>
          </button>

          <button type="button" class="inside-dhaka-outside-btn" style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 18px 12px;
            border: 2px solid rgba(139, 58, 42, .35);
            border-radius: 12px;
            background: rgba(253, 250, 244, .85);
            cursor: pointer;
            transition: all .18s ease;
            font-family: inherit;
          ">
            <span style="font-size: 26px; margin-bottom: 6px; display: block;">&#127759;</span>
            <span style="font-size: 15px; font-weight: 700; color: #6b2a1e; display: block;">ঢাকার বাইরে</span>
            <span style="font-size: 12px; color: #7a5540; margin-top: 3px; display: block;">অন্যান্য জেলা</span>
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const closeBtn = modal.querySelector('.inside-dhaka-modal-close');
    const insideBtn = modal.querySelector('.inside-dhaka-inside-btn');
    const outsideBtn = modal.querySelector('.inside-dhaka-outside-btn');

    insideBtn.addEventListener('mouseenter', () => {
      insideBtn.style.background = '#8b3a2a';
      insideBtn.style.borderColor = '#8b3a2a';
      insideBtn.style.transform = 'translateY(-2px)';
    });
    insideBtn.addEventListener('mouseleave', () => {
      insideBtn.style.background = '#6b2a1e';
      insideBtn.style.borderColor = '#6b2a1e';
      insideBtn.style.transform = 'none';
    });

    outsideBtn.addEventListener('mouseenter', () => {
      outsideBtn.style.borderColor = '#8b3a2a';
      outsideBtn.style.background = '#f5e9d5';
      outsideBtn.style.transform = 'translateY(-2px)';
    });
    outsideBtn.addEventListener('mouseleave', () => {
      outsideBtn.style.borderColor = 'rgba(139, 58, 42, .35)';
      outsideBtn.style.background = 'rgba(253, 250, 244, .85)';
      outsideBtn.style.transform = 'none';
    });

    const closeModal = () => {
      modal.remove();
      callback(null);
    };

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // Inside Dhaka selected -> directly go to /checkout
    insideBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.remove();
      callback('inside');
    });

    // Outside Dhaka selected -> directly show sorry modal!
    outsideBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.remove();
      callback('outside');
    });
  }

  // Create and show polite sorry explanation modal
  function showSorryModal() {
    const existing = document.getElementById('inside-dhaka-sorry-modal');
    if (existing) existing.remove();

    const sorryModal = document.createElement('div');
    sorryModal.id = 'inside-dhaka-sorry-modal';
    sorryModal.className = 'inside-dhaka-modal-overlay';
    sorryModal.style.cssText = `
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(40, 12, 6, 0.62);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999999;
      padding: 20px;
    `;

    sorryModal.innerHTML = `
      <div class="deshio-dhaka-card" style="
        background: linear-gradient(180deg, #fdfaf4 0%, #f5e9d5 100%);
        border: 1px solid rgba(139, 58, 42, .22);
        border-radius: 16px;
        padding: 34px 26px 26px;
        max-width: 470px;
        width: 100%;
        text-align: center;
        box-shadow: 0 22px 60px -18px rgba(40, 12, 6, .55);
        position: relative;
        font-family: 'Hind Siliguri', 'GeneralSans', system-ui, sans-serif;
      ">
        <button class="inside-dhaka-sorry-close" style="
          position: absolute;
          top: 12px;
          right: 12px;
          width: 34px;
          height: 34px;
          background: rgba(74, 42, 24, .08);
          border: 1px solid rgba(74, 42, 24, .16);
          border-radius: 9px;
          font-size: 17px;
          cursor: pointer;
          color: #4a2a18;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        " aria-label="Close">&#10005;</button>

        <div style="
          width: 58px;
          height: 58px;
          background: #6b2a1e;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 14px auto;
          font-size: 27px;
          box-shadow: 0 6px 16px -6px rgba(40, 12, 6, .6);
        ">&#128205;</div>

        <h3 style="
          font-size: 20px;
          font-weight: 700;
          color: #6b2a1e;
          margin: 0 0 12px 0;
          line-height: 1.45;
        ">শুধুমাত্র ঢাকার ভিতরে ডেলিভারি</h3>

        <p style="
          font-size: 14.5px;
          line-height: 1.8;
          color: #5c3317;
          margin: 0 0 22px 0;
          text-align: left;
        ">
          আমরা আন্তরিকভাবে দুঃখিত! আপনার কার্টে থাকা এক বা একাধিক পণ্য সর্বোচ্চ সতেজতা ও আসল স্বাদ বজায় রাখতে <strong style="color: #8b3a2a; font-weight: 700;">শুধুমাত্র ঢাকার ভিতরে</strong> ডেলিভারির জন্য উপলব্ধ।<br><br>
          দুঃখজনকভাবে, ঢাকার বাইরে এই পণ্যগুলোর ডেলিভারি আমরা দিতে পারছি না। অনুগ্রহ করে <strong style="color: #8b3a2a; font-weight: 700;">ঢাকার ভিতরে</strong> নির্বাচন করুন অথবা ঢাকা-নির্দিষ্ট পণ্যগুলো কার্ট থেকে সরিয়ে অর্ডারটি সম্পন্ন করুন।
        </p>

        <button type="button" class="inside-dhaka-sorry-btn" style="
          background: #6b2a1e;
          color: #f7e6c4;
          border: none;
          padding: 14px 24px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          width: 100%;
          transition: background .18s ease;
          font-family: inherit;
        ">বুঝেছি, কার্ট আপডেট করুন</button>
      </div>
    `;

    document.body.appendChild(sorryModal);

    const closeBtn = sorryModal.querySelector('.inside-dhaka-sorry-close');
    const actionBtn = sorryModal.querySelector('.inside-dhaka-sorry-btn');

    const closeModal = () => sorryModal.remove();
    closeBtn.addEventListener('click', closeModal);
    actionBtn.addEventListener('click', closeModal);
    sorryModal.addEventListener('click', (e) => {
      if (e.target === sorryModal) closeModal();
    });
  }

  // ---------------------------------------------------------------
  // Delivery-rate notice
  //
  // Shown after the customer picks an area, so they reach payment
  // already knowing what delivery will cost. It only INFORMS — the
  // charge itself is set in Shopify admin (Settings > Shipping and
  // delivery), and nothing here changes what is billed.
  //
  // The threshold and the two prices per area live in one place
  // below; if the rates change in admin, change them here to match.
  // ---------------------------------------------------------------
  var DELIVERY = {
    threshold: 600,
    inside:  { low: 90, high: 50, label: 'ঢাকার ভিতরে' },
    outside: { low: 120, high: 70, label: 'ঢাকার বাইরে' }
  };

  // Cart total in TAKA. /cart.js is the authoritative figure and is
  // already loaded by the time a checkout button can be clicked;
  // reading the rendered subtotal text would mean parsing a money
  // string, which breaks the moment the currency format changes.
  function getCartTotal() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c.total_price || 0) / 100; })
      .catch(function () { return null; });
  }

  function taka(n) { return '৳' + n; }

  function showDeliveryRateModal(area, onContinue) {
    var existing = document.getElementById('deshio-rate-modal');
    if (existing) existing.remove();

    var cfg = DELIVERY[area];

    getCartTotal().then(function (total) {
      // total === null means the fetch failed. Both rates are then
      // shown with neither highlighted, rather than guessing wrong
      // and promising a price the customer will not be charged.
      var qualifies = total === null ? null : total >= DELIVERY.threshold;
      var charge = qualifies === null ? null : (qualifies ? cfg.high : cfg.low);
      var short = (qualifies === false && total !== null)
        ? Math.ceil(DELIVERY.threshold - total) : 0;

      var modal = document.createElement('div');
      modal.id = 'deshio-rate-modal';
      modal.className = 'inside-dhaka-modal-overlay';
      modal.style.cssText = [
        'position: fixed', 'top: 0', 'left: 0', 'right: 0', 'bottom: 0',
        'background-color: rgba(40, 12, 6, 0.62)', 'display: flex',
        'align-items: center', 'justify-content: center',
        'z-index: 9999999', 'padding: 20px'
      ].join(';');

      // The qualifying row is the one that applies; the other is shown
      // greyed so the customer can see the rule, not just the number.
      function row(amountTk, caption, active) {
        return '' +
          '<div class="deshio-rate-row' + (active ? ' is-active' : '') + '">' +
            '<span class="deshio-rate-row__cap">' + caption + '</span>' +
            '<span class="deshio-rate-row__amt">' + taka(amountTk) + '</span>' +
          '</div>';
      }

      var rowsHtml =
        row(cfg.high, DELIVERY.threshold + ' টাকা বা তার বেশি অর্ডারে', qualifies === true) +
        row(cfg.low, DELIVERY.threshold + ' টাকার কম অর্ডারে', qualifies === false);

      var headline;
      if (qualifies === true) {
        headline = '<p class="deshio-rate-note deshio-rate-note--good">' +
          'আপনার অর্ডারে ডেলিভারি চার্জ <strong>' + taka(charge) + '</strong></p>';
      } else if (qualifies === false) {
        headline = '<p class="deshio-rate-note">' +
          'আপনার অর্ডারে ডেলিভারি চার্জ <strong>' + taka(charge) + '</strong>। ' +
          'আর <strong>' + taka(short) + '</strong> এর পণ্য যোগ করলে চার্জ হবে ' +
          '<strong>' + taka(cfg.high) + '</strong>।</p>';
      } else {
        headline = '<p class="deshio-rate-note">অর্ডারের পরিমাণ অনুযায়ী ডেলিভারি চার্জ প্রযোজ্য হবে।</p>';
      }

      modal.innerHTML =
        '<div class="deshio-dhaka-card deshio-rate-card">' +
          '<button class="deshio-rate-close" aria-label="Close">&#10005;</button>' +
          '<div class="deshio-rate-icon">&#128666;</div>' +
          '<h3 class="deshio-rate-title">ডেলিভারি চার্জ — ' + cfg.label + '</h3>' +
          headline +
          '<div class="deshio-rate-rows">' + rowsHtml + '</div>' +
          '<p class="deshio-rate-fine">চার্জ চেকআউটে যোগ হবে।</p>' +
          '<button type="button" class="deshio-rate-go">পেমেন্টে যান</button>' +
          '<button type="button" class="deshio-rate-back">কার্টে ফিরে যান</button>' +
        '</div>';

      document.body.appendChild(modal);

      var close = function () { modal.remove(); };
      modal.querySelector('.deshio-rate-close').addEventListener('click', close);
      modal.querySelector('.deshio-rate-back').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      modal.querySelector('.deshio-rate-go').addEventListener('click', function () {
        modal.remove();
        onContinue();
      });
    });
  }

  // Handle Checkout validation
  //
  // The location question now runs on EVERY checkout, not only carts
  // holding Dhaka-only stock — otherwise the outside-Dhaka delivery
  // rate could never be shown, because that branch always ended at
  // the sorry modal.
  //
  //   any cart      -> where to?
  //     inside      -> rate notice -> checkout
  //     outside     -> cart has Dhaka-only items ? sorry : rate notice -> checkout
  function handleCheckoutValidation(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    var goToCheckout = function () { window.location.href = '/checkout'; };

    showLocationModal(function (location) {
      if (location === 'inside') {
        showDeliveryRateModal('inside', goToCheckout);
      } else if (location === 'outside') {
        // Dhaka-only products still cannot travel; that message comes
        // first and there is no rate to quote.
        if (hasInsideDhakaProducts()) {
          showSorryModal();
        } else {
          showDeliveryRateModal('outside', goToCheckout);
        }
      }
      // location === null: the customer dismissed the modal. Nothing
      // happens and they stay on the cart, which is what they asked for.
    });

    return false;
  }

  // Intercept click on any checkout button using capture phase
  document.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('.bls-btn-checkout, [name="checkout"], #checkout, a[href*="/checkout"], .cart__checkout-button');
    if (checkoutBtn) {
      if (!handleCheckoutValidation(e)) {
        return false;
      }
    }
  }, true);

  // Intercept form submissions targeting checkout
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && (form.id === 'cart' || form.id === 'form-mini-cart' || form.classList.contains('checkout-form') || (form.action && form.action.includes('/cart')))) {
      const submitter = e.submitter;
      if (!submitter || submitter.name === 'checkout' || submitter.classList.contains('bls-btn-checkout') || submitter.id === 'checkout') {
        if (!handleCheckoutValidation(e)) {
          return false;
        }
      }
    }
  }, true);

})();

